import { useState } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { WorkDisplayPeriod } from "@baseTypes/service/dashboard/IWorksDashboardService";

const usePeriodParam = (paramName: string) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [period, setPeriod] = useState<WorkDisplayPeriod>(
        (searchParams.get(paramName) || 'full') as WorkDisplayPeriod
    );

    const updatePeriod = (newPeriod: WorkDisplayPeriod) => {
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.set(paramName, newPeriod);

        setPeriod(newPeriod);
        navigate({ search: `?${newSearchParams.toString()}` }, { replace: true });
    };

    return [period, updatePeriod];
};

export default usePeriodParam